import React from 'react';
import styled from 'styled-components';
import SearchSuggestions from '../../atoms/SearchSuggestions';
import useSearchAreaSuggestionsLogic from './useSearchAreaSuggestionsLogic';
import HelperText from './HelperText';
import { SEARCH_AREA_INPUT_ID } from '../../constants';

const SEARCH_AREA_SUGGESTIONS_OPTIONS = {
  IDS: {
    SEARCH_AREAS: 'searchAreas',
  },
};

const SEARCH_AREA_SUGGESTIONS_CONSTS = {
  EMPHASIS: false,
  HEADING: undefined,
  HIGHLIGHT_MATCH: true,
  HOVER_ICON: false,
};

const StyledContainer = styled.div`
  min-width: 100%;
`;

const SearchAreaSuggestions = () => {
  const {
    handleSuggestionClick,
    suggestions,
  } = useSearchAreaSuggestionsLogic();

  return (
    <StyledContainer>
      <SearchSuggestions
        emphasis={SEARCH_AREA_SUGGESTIONS_CONSTS.EMPHASIS}
        fieldId={SEARCH_AREA_INPUT_ID}
        handleSuggestionClick={handleSuggestionClick}
        Helper={HelperText}
        highlightMatch={SEARCH_AREA_SUGGESTIONS_CONSTS.HIGHLIGHT_MATCH}
        hoverIcon={SEARCH_AREA_SUGGESTIONS_CONSTS.HOVER_ICON}
        suggestions={suggestions}
      />
    </StyledContainer>
  );
};

export default SearchAreaSuggestions;
export { SEARCH_AREA_SUGGESTIONS_OPTIONS };
